import { render } from "./addRestriction.html?vue&type=template&id=6eccceff&scoped=true&ts=true&external"
import script from "./AddRestriction.vue?vue&type=script&lang=ts"
export * from "./AddRestriction.vue?vue&type=script&lang=ts"

import "./AddRestriction.vue?vue&type=style&index=0&id=6eccceff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eccceff"]])

export default __exports__